<h1 mat-dialog-title>Submit Bank Deposit Slip for <strong>Property Id:</strong> {{ data.property_id }}</h1>
<div mat-dialog-content>
    <div class="row m-2">
        <form class="col-sm-12 row m-auto" [formGroup]="basicInfoForm">
            <div class="col-sm-12 image-holder">
                <img *ngIf="!imgURL" src="assets/placeholder-image.png" />
                <img *ngIf="imgURL" [src]="imgURL" />
                <div class="file-chooser">
                  <p class="text-center">Select Voucher Image</p>
                  <input (change)="fileChangeEvent($event)" type="file">
                </div>
            </div>
            <div class="col-sm-12 form-group">
                <label for="remarks">
                    Remarks
                </label>
                <textarea class="form-control" formControlName="remarks" id="remarks" value="remarks"></textarea>  
            </div>
        </form>
    </div>
</div>
<div mat-dialog-actions class="row col-sm-12 justify-content-end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button (click)="saveBankDepositInfo()" cdkFocusInitial>Save</button>
</div>